import React, { useState, useRef } from 'react';

const SelectOption = ({ id, title, options, activeOptions, handleCourseFilter }) => {
  const [isOptionsVisible, setOptionsVisible] = useState(false);
  const containerRef = useRef(null);

  const handleOptionClick = (option) => {
    setOptionsVisible(false);
	 handleCourseFilter(option, id, false, false);
  };


  const toggleOptions = () => {
    setOptionsVisible(!isOptionsVisible);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleOptions();
    } else if (event.key === 'Escape') {
      setOptionsVisible(false);
    }
  };

  return (
    <div
      className={`custom-select ${isOptionsVisible ? 'open' : ''}`}
      ref={containerRef}
      tabIndex="0"
      onKeyDown={handleKeyDown}
    >
      <div
        className="custom-select__select"
        onClick={toggleOptions}
        aria-haspopup="listbox"
        aria-expanded={isOptionsVisible}
      >
			{/* <span>{activeOptions.length > 0 ? Object.values(activeOptions[0])[0] : title}</span> */}
        <span>{title}</span>
		  <div className="custom-select__icon">
		  	<span className={`custom-select__arrow ${isOptionsVisible ? 'up' : 'down'}`}></span>
		  </div>

      </div>
      {isOptionsVisible && (
        <ul className="custom-select__options" role="listbox">
          {options.map((option, index) => (
            <li
              className={`custom-select__option ${
					 (activeOptions.length > 0 && activeOptions[0] === option) ? 'selected' : ''
              }`}
              key={index}
              onClick={() => handleOptionClick(option)}
              role="option"
              aria-selected={activeOptions.length > 0 && activeOptions[0] === option}
              tabIndex="0"
            >
              {Object.values(option)[0]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectOption;

